const MAX_TOTAL_FILE_SIZE_10 = 10 * 1024 * 1024;
const MAX_TOTAL_FILE_SIZE_5 = 5 * 1024 * 1024;

export {MAX_TOTAL_FILE_SIZE_10, MAX_TOTAL_FILE_SIZE_5};
